var render, staticRenderFns
import script from "./HyperlinkKpiTechnicalSupportTotal.vue?vue&type=script&lang=js&"
export * from "./HyperlinkKpiTechnicalSupportTotal.vue?vue&type=script&lang=js&"
import style0 from "./HyperlinkKpiTechnicalSupportTotal.vue?vue&type=style&index=0&id=045ddeb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ddeb0",
  null
  
)

export default component.exports